"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.773 3.937v10.596c0 3.476-5.766 7.177-9.773 8.422-4.008-1.245-9.774-4.946-9.774-8.422V3.937L12 1.044l9.773 2.893Zm.634-.923L12.114.005 11.92 0 1.588 3.015c-.348.116-.4.372-.4.513v11.005c0 4.435 6.967 8.351 10.697 9.462l.212.005.017-.005c3.73-1.111 10.698-5.027 10.698-9.462V3.528c0-.216-.193-.41-.405-.514ZM6.782 11.279a.504.504 0 0 0-.729 0 .504.504 0 0 0 0 .729l3.958 3.96c.116.114.311.114.405.114.104 0 .246 0 .292-.11a.144.144 0 0 0 .011-.063l7.068-7.068c.1-.1.156-.23.156-.365a.514.514 0 0 0-.156-.364.505.505 0 0 0-.729 0l-6.722 6.722-3.554-3.555Z",
    clipRule: "evenodd"
  })]
});